<template>
  <div>
    <b-row>
      <b-col xs="12" sm="12" md="6" :lg="isCanAddPeriod ? '4' : '6'" :xl="isCanAddPeriod ? '4' : '6'">
        <SelectStatic title="Tipo" fieldTarget="typePrice" :data="options" :required="true" :markFormDirty="false"
          v-model="collaboratorPriceTable.typePrice" />
      </b-col>
      <b-col xs="12" sm="6" md="3" lg="3" xl="3" v-if="isCanAddPeriod">
        <InputNumber title="Período" field="quantity" :formName="formName" :required="true" :maxLength="3"
          type="int" :markFormDirty="false" v-model="collaboratorPriceTable.quantity" />
      </b-col>
      <b-col xs="12" sm="6" :md="isCanAddPeriod ? '3' : '6'" :lg="isCanAddPeriod ? '5' : '6'"
        :xl="isCanAddPeriod ? '5' : '6'">
        <InputDecimal title="Valor" field="value" :formName="formName" :required="true" :markFormDirty="false"
          v-model="collaboratorPriceTable.value" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="9">
        <div class="collaborator-price-table-create-update-checkbox text-right">
          <CheckboxSimple title="Salvar e novo" v-model="addOtherPeriod" />
        </div>
      </b-col>
      <b-col sm="3">
        <div class="text-right">
          <Button _key="btnSaveCollaboratorPriceTable" type="success" title="Salvar"
            :disabled="!isFormValid(formName)" classIcon="fas fa-save" size="medium" :clicked="save" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputDecimal from "@/ui/forms/InputDecimal";
import InputNumber from "@/ui/forms/InputNumber";
import SelectStatic from "@/ui/forms/SelectStatic";
import CheckboxSimple from "@/ui/forms/CheckboxSimple";
import Button from "@/ui/forms/Button";

import CollaboratorPriceTable from "../models/CollaboratorPriceTable.js";
import CollaboratorPriceTableService from "../services/collaboratorPriceTable.service.js";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "CollaboratorPriceTableCreateUpdate",
  props: {
    collaboratorId: String,
  },
  components: {
    InputDecimal,
    InputNumber,
    SelectStatic,
    CheckboxSimple,
    Button,
  },
  data() {
    return {
      formName: "collaboratorPriceTableCreateUpdate",
      collaboratorPriceTable: new CollaboratorPriceTable(),
      addOtherPeriod: false,
      options: [
        { content: "Minuto", id: "1" },
        { content: "Hora", id: "2" },
        { content: "Dia", id: "3" },
        { content: "Mês", id: "4" },
        { content: "Ano", id: "5" },
        { content: "Valor Único", id: "6" },
      ],
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
    isCanAddPeriod() {
      return this.collaboratorPriceTable.typePrice.id != "6" && this.collaboratorPriceTable.typePrice.id != "";
    },
  },
  methods: {
    ...mapMutations("generic", ["removeLoading", "hideModal", "addEvent"]),
    ...mapMutations("validation", ["resetValidation"]),
    async save() {
      this.collaboratorPriceTable.collaboratorId = this.collaboratorId;
      try {
        await CollaboratorPriceTableService.save(this.collaboratorPriceTable);
        this.addEvent({ name: "getAllListViewWithDataHandler" });
        if (!this.addOtherPeriod) {
          this.hideModal();
        } else {
          this.resetValidation(this.formName);
          this.collaboratorPriceTable = new CollaboratorPriceTable();
        }
      } finally {
        this.removeLoading(["btnSaveCollaboratorPriceTable"]);
      }
    },
    update(data) {
      this.collaboratorPriceTable = new CollaboratorPriceTable();
      this.collaboratorPriceTable.update(data);
      this.removeLoading([data.id]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "collaboratorPriceTableCreate") {
          this.resetValidation(this.formName);
          this.collaboratorPriceTable = new CollaboratorPriceTable();
        }
        if (event.name == "updateCollaboratorPriceTable") this.update(event.data);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.collaborator-price-table-create-update-checkbox {
  padding-top: 8px;
}
</style>
